import React from 'react';
import {
  string,
  bool,
  func,
  arrayOf,
  shape,
} from 'prop-types';

import { StyledSelect } from './SelectStyles';

const Select = ({
  id,
  errorMsg,
  required,
  value,
  onChange,
  options,
}) => (
  <StyledSelect
    id={id}
    className={errorMsg?.length ? 'error' : ''}
    required={required}
    value={value}
    aria-required={required}
    aria-describedby={`${id}_error`}
    onChange={(e) => { if (onChange) onChange(e); }}
  >

    {
      options.map((o) => (
        <option
          disabled={Object.hasOwnProperty.call(o, 'disabled') ? o.disabled : false}
          key={`${id}_${btoa(o.value || '(none)')}`}
          value={Object.prototype.hasOwnProperty.call(o, 'value') ? o.value : o.display}
        >
          {o.display}
        </option>
      ))
    }
  </StyledSelect>
);

Select.propTypes = {
  id: string.isRequired,
  errorMsg: string,
  required: bool,
  value: string,
  onChange: func,
  options: arrayOf(shape({
    disabled: bool,
    display: string.isRequired,
    value: string,
  })).isRequired,
};

Select.defaultProps = {
  errorMsg: null,
  required: false,
  value: '',
  onChange: null,
};

export default Select;